import { handleScroll } from './handle-scroll'

( function ( $ ) {


    $('.js-show-image').css('display', 'block')

    window.addEventListener('load', () => {
        if (window.location.hash) {
            handleScroll();  // Call handleScroll on page load if there's a hash
        }
    });

    // After change url hash provide "handleScroll"
    window.addEventListener('hashchange', handleScroll);
    
    //document.addEventListener('DOMContentLoaded', handleScroll );

} )( jQuery );